module.exports = __webpack_public_path__ + "static/media/AdminNómina_DíaAjuste.c0cb881d.svg";